<!-- Welcome Component without Widget Class -->
<mat-card class="mat-elevation-z0 p-4" *ngIf="listOfUserInfo">
    <!-- Header Section -->
    <mat-card-header *ngIf="!hideTitle" class="p-0 mb-2 block">
        <mat-card-title>
            {{ 'tx-welcome.welcome' | translate }} {{ listOfUserInfo.name }}
        </mat-card-title>
        <mat-card-subtitle *ngIf="listOfUserInfo.state_name">
            {{ 'txBuchungen.userState' | translate}}: {{ listOfUserInfo.state_name }}
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content class="ps-4">
        <!-- Offline Bookings Section -->
        <div *ngIf="offlineBookings > 0" class="mb-2">
            <p class="font-bold">{{ 'txBuchungen.bookingsInQueue' | translate }}: {{ offlineBookings }}</p>
        </div>

        <!-- User Info Section -->
        <div *ngIf="listOfUserInfo.user_info !== undefined"
             [innerHTML]="listOfUserInfo.user_info !== undefined ? listOfUserInfo.user_info : ''">
        </div>
    </mat-card-content>
</mat-card>
